import axios from "axios";

//api-url от backend

// export const BaseUrl="https://aida.ao-zdrm.ru/api"
export const BaseUrl="/api"

const Api = async(data) => {
    try {
        const api_data=data;
        api_data.url=`${BaseUrl}${api_data.url}`;

        if ("headers" in api_data){
            const headers_data = JSON.parse(sessionStorage.getItem('user_data'));
            api_data["headers"]["api-session-key"]=headers_data.api_session_key;
        }

        const response= await axios(api_data);
        return(response);
    } catch (error) {
        console.error(error);
        // console.log(Object.keys(error));
        // console.log(Object.entries(error))
        // throw new Error(JSON.stringify(error.response));
        throw errorMessageText(error)
    }
}

export const errorMessageText = (error) => {
    try {
        switch(error.status){
            case 401:
                return `Неверный логин/пароль.\n Подробности: ${error.response.data.detail || "Информация отсутствует"}.`
                break
            default:
                return `Подробности: ${error.response.data.detail || "Информация отсутствует"}.`
        }   
    } catch (error_second) {
        return `Ошибка. \n Сообщение: ${error.message}.`
    }
}

export default Api;